import { render, staticRenderFns } from "./CgProjectManage.vue?vue&type=template&id=6e5d1334&"
import script from "./CgProjectManage.vue?vue&type=script&lang=js&"
export * from "./CgProjectManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports